import { createApp } from 'vue';
import AppComponent from './AppComponent.vue';
import router from './router';
import store from './store';
import axios from './axios';
import 'vue-multiselect/dist/vue-multiselect.css';
import './assets/css/design-tokens.css';
import './assets/css/content-cards.css';
import './assets/css/editor.css';

const app = createApp(AppComponent);
app.use(router);
app.use(store);
app.config.globalProperties.$axios = axios;
app.mount('#app');
